// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__394pf","insightsList":"newBusinessInsightsMenu_insightsList__1gaxI","active":"newBusinessInsightsMenu_active__YzP9Z"};